<app-camera-facial
  *ngIf="ativa && modo === 'registro'"
  [modo]="modo"
  [margemSuperior]="margemSuperior"
  [rostoDetectado]="rostoDetectado"
  [provaVidaOk]="provaVidaOk"
  [capturando]="capturando"
  [mensagem]="mensagem"
  [caixaFace]="caixaFace"
  [zoomVisual]="zoomVisual"
  (confirmar)="confirmar.emit()">
</app-camera-facial>
